<div class="_flex _flex-col sm:_flex-row _relative _rounded-lg _bg-white _card">
    <ng-container *ngIf="listing?.operator?.logoUrl">
        <div class="_absolute _top-2 _-left-2 _border _border-transparency-black-25 _rounded _overflow-hidden _shadow _z-10">
            <app-operator-logo [width]="73" [height]="73" [operator]="listing.operator"></app-operator-logo>
        </div>
    </ng-container>
    <div class="_rounded-t-lg sm:_rounded _overflow-hidden sm:_max-w-40% md:_max-w-none">
        <img class="_card-image _w-full _h-full _object-cover" 
            loading="lazy" 
            app-imagekit
            [source]="listingSummary?.photos[0]?.url" 
            width="350" 
            height="240" 
            transform="tr:w-350,h-240,fo-auto">
    </div>
    <div class="_rounded-lg _flex-1 _px-5 _py-3 _bg-white">
        <div class="_mb-4 sm:_mb-7 _text-center sm:_text-left">
            <ng-container *ngIf="listingSummary.city">
                <div class="listing-location text-small">
                    <span>{{ listingSummary.city }}, </span>
                    <app-country-code [countryCode]="listingSummary.countryCode"></app-country-code>
                </div>
            </ng-container>
            <div *ngIf="publicListing" class="_mt-2">Login or signup to view</div>
            <div *ngIf="!publicListing" class="_h4 _mt-2">{{ listingSummary.title | slice:0:40 }}</div>
        </div>
        <div class="_flex _justify-between _text-md _flex-col sm:_flex-row">
            <div class="_flex _flex-wrap _flex-row sm:_flex-col sm-max:_justify-evenly sm-max:_bg-primary-1-tint-4 sm-max:_p-2 _gap-2 _rounded-md sm:_max-w-40%">
                <ng-container *ngFor="let decidingFactor of listingSummary.decidingFactors.primaryDecidingFactors">
                    <app-listing-deciding-factor 
                        [titleOnly]="true" 
                        [decidingFactor]="decidingFactor">
                    </app-listing-deciding-factor>
                </ng-container>
            </div>
            <div *ngIf="publicListing" class="_flex _flex-wrap _flex-row-reverse sm:_flex-col sm-max:_items-center sm-max:_mt-4 sm-max:_justify-between _gap-2">    
                <div class="_flex _items-center" inert>
                    Rates from <span class="_pill _ml-1 xs:_ml-2">$<span class="_blurry-text-light _ml-2">12,000</span></span>
                </div>
                <div inert *ngIf="!consumerView">Up to <span class="_blurry-text-dark _mr-1">25</span>% commission</div>
            </div>

            <div *ngIf="!publicListing && searchListing.fees && isAvailable()" 
                class="_flex _flex-wrap _flex-row-reverse sm:_flex-col sm-max:_items-center sm-max:_mt-4 sm-max:_justify-between _gap-2">    
                <div class="_flex _items-center _justify-end">
                    Rates from 
                    <span class="_pill _ml-1 xs:_ml-2 _font-bold">
                        <app-booking-price [fees]="searchListing.fees"></app-booking-price>
                    </span>
                </div>
                <div [ngClass]="{'_tooltip' : !searchListing.commission}">
                    <ng-container *ngIf="searchListing.commission && !consumerView">
                        <app-reseller-commission-calculation 
                            [exactFee]="searchListing.fees"
                            [commission]="searchListing.commission">
                        </app-reseller-commission-calculation>
                    </ng-container>
                    <ng-container *ngIf="!searchListing.commission && !consumerView">
                        <div>Up to <span class="_blurry-text-dark _mr-1">25</span>% commission</div>
                        <span class="_tooltiptext _tooltip-x-below _tooltip-y-right">Your profile is being reviewed. Once approved you will see commissions and be able to book directly</span>
                    </ng-container>
                </div>
            </div>

            <div *ngIf="!publicListing && searchListing.availableFrom" 
                class="_flex _flex-wrap _flex-row-reverse sm:_flex-col sm-max:_items-center sm-max:_mt-4 sm-max:_justify-between _gap-2">    
                <div class="_flex _items-center _justify-end">
                    Rates from 
                    <span class="_pill _ml-1 xs:_ml-2 _font-bold">
                        <app-booking-price-range [priceRange]="searchListing.priceRange"></app-booking-price-range>
                    </span>
                </div>
                <div [ngClass]="{'_tooltip' : !searchListing.commission}">
                    <ng-container *ngIf="searchListing.commission && !consumerView">
                        <app-reseller-commission-calculation 
                        [exactFee]="searchListing.priceRange.lowest"
                        [commission]="searchListing.commission">
                    </app-reseller-commission-calculation>
                    </ng-container>
                    <ng-container *ngIf="!searchListing.commission && !consumerView">
                        <div>Up to <span class="_blurry-text-dark _mr-1">25</span>% commission</div>
                        <span class="_tooltiptext _tooltip-x-below _tooltip-y-right">Your profile is being reviewed. Once approved you will see commissions and be able to book directly</span>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
